import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaUserTie, FaEnvelope, FaLock, FaUser, FaPhone, FaBuilding } from 'react-icons/fa';
import Select from 'react-select/async';
import Topbar from '../layouts/Topbar';
import Sidebar from '../layouts/Sidebar';
import './CreateAdminManager.css';

const CreateAdminManager = () => {
    const navigate = useNavigate();
    const baseUrl = "https://api.burrayhr.com";
    const [loading, setLoading] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [formData, setFormData] = useState({
        email: '',
        password: '1234',
        first_name: '',
        last_name: '',
        phone_number: '+263',
        company: '',
        contract_type: 'open',
        category: 'managerial'
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleCompanyChange = (selectedOption) => {
        console.log('Selected Company:', selectedOption);
        setSelectedCompany(selectedOption);
        setFormData({
            ...formData,
            company: selectedOption ? selectedOption.value : ''
        });
    };

    // Load companies for the select field
    const loadCompanies = async (inputValue) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${baseUrl}/api/companies`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });

            const options = response.data
                .filter(company => 
                    company.name.toLowerCase().includes(inputValue.toLowerCase())
                )
                .map(company => ({
                    value: company.id,
                    label: company.name
                }));

            return options;
        } catch (error) {
            console.error('Error loading companies:', error);
            return [];
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (!selectedCompany) {
                throw new Error('Please select a company');
            }

            const submitData = {
                ...formData,
                company: selectedCompany.value
            };

            console.log('Submitting form data:', submitData);

            const token = localStorage.getItem('token');
            const response = await axios.post(`${baseUrl}/api/admin-managers/`, submitData, {
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 201) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: 'Admin manager created successfully',
                    confirmButtonColor: '#1e3a8a'
                });
                navigate('/admin-managers/view');
            }
        } catch (error) {
            console.log('Error details:', error.response?.data);
            
            // Handle specific error cases
            if (error.response?.status === 400) {
                const errorData = error.response.data;
                
                // Check for email-related errors
                if (errorData.email) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Email Already Exists',
                        text: 'This email address is already registered in the system. Please use a different email address.',
                        confirmButtonColor: '#1e3a8a'
                    });
                } else if (errorData.detail) {
                    // Handle other validation errors
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Error',
                        text: errorData.detail,
                        confirmButtonColor: '#1e3a8a'
                    });
                } else {
                    // Generic 400 error
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Input',
                        text: 'This email address is already registered in the system. Please use a different email address.',
                        confirmButtonColor: '#1e3a8a'
                    });
                }
            } else if (error.response?.status === 401) {
                // Handle unauthorized access
                Swal.fire({
                    icon: 'error',
                    title: 'Session Expired',
                    text: 'Your session has expired. Please login again.',
                    confirmButtonColor: '#1e3a8a'
                }).then(() => {
                    localStorage.removeItem('token');
                    navigate('/login');
                });
            } else {
                // Handle other errors
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: error.response?.data?.message || 'Failed to create admin manager. Please try again.',
                    confirmButtonColor: '#1e3a8a'
                });
            }
        } finally {
            setLoading(false);
        }
    };

  return (
    <div>
      <Topbar />
      <Sidebar />
            <div className="main-content">
                <div className="create-admin-container">
                    <div className="create-admin-header">
                        <FaUserTie className="header-icon" />
                        <h1>Add New Admin Manager</h1>
    </div>
                    
                    <form onSubmit={handleSubmit} className="create-admin-form">
                            <div className="form-group">
                                <label htmlFor="first_name">
                                    <FaUser /> First Name
                                </label>
                                <input
                                    type="text"
                                    id="first_name"
                                    name="first_name"
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    placeholder="Enter first name"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="last_name">
                                    <FaUser /> Last Name
                                </label>
                                <input
                                    type="text"
                                    id="last_name"
                                    name="last_name"
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    placeholder="Enter last name"
                                    required
                                />
                            </div>

                        <div className="form-group">
                            <label htmlFor="email">
                                <FaEnvelope /> Email
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Enter email address"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phone_number">
                                <FaPhone /> Phone Number
                            </label>
                            <input
                                type="tel"
                                id="phone_number"
                                name="phone_number"
                                value={formData.phone_number}
                                onChange={handleChange}
                                placeholder="Enter phone number"
                                required
                            />
                        </div>

                        <div className="form-group">
                            <label>
                                <FaBuilding /> Company
                            </label>
                            <Select
                                cacheOptions
                                defaultOptions
                                loadOptions={loadCompanies}
                                onChange={handleCompanyChange}
                                value={selectedCompany}
                                placeholder="Search and select company"
                                className="company-select"
                                isClearable
                                isSearchable
                                required
                                noOptionsMessage={() => "No companies found"}
                            />
                        </div>

                        <div className="form-actions">
                            <button 
                                type="button" 
                                className="cancel-btn"
                                onClick={() => navigate('/admin-managers/view')}
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit" 
                                className="submit-btn" 
                                disabled={loading || !selectedCompany}
                            >
                                {loading ? 'Creating...' : 'Create Admin Manager'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default CreateAdminManager;
